import { isEmpty } from "lodash";
import { Navigate, Routes, Route } from "react-router-dom";

import AuthContext from "../../context/Auth/AuthContext";
import LoginAuth from "../../components/Auth/LoginAuth/LoginAuth";
import LogoutAuth from "./../../components/Auth/LogoutAuth/LogoutAuth";
import { baseRoute, getCookies } from "../../utils";

const AuthContainer = ({ isOrgan = false }) => {
  const accessToken = getCookies("accessToken");

  const isLogin = !isEmpty(accessToken);

  return (
    <Routes>
      {/* Sign Out Component */}
      <Route path="/Logout" element={<LogoutAuth isOrgan={isOrgan} />} />

      {/* Sign In Component */}
      <Route
        path="/Sign-In"
        element={
          isLogin ? (
            <Navigate
              to={baseRoute(
                isOrgan,
                `/${isOrgan ? "Organ" : "Admin"}/Dashboard`
              )}
            />
          ) : (
            <AuthContext isOrgan={isOrgan}>
              <LoginAuth />
            </AuthContext>
          )
        }
      />

      {/* Redirect Not Found Page */}
      <Route
        path="/*"
        element={<Navigate to={baseRoute(isOrgan, "/Not-Found")} />}
      />
    </Routes>
  );
};

export default AuthContainer;
